import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';
import {
    LinkBuyerRequest,
    LinkBuyerResult,
} from '../models/link-buyer.model';

export interface LinkBuyerByAdminArg {
    engagementId: number;
    buyerId: number;
}

const GENERIC_ERROR_MESSAGE = 'An error occurred while linking the buyer.';

const extractServerMessage = (error: any): string => {
    const data = error?.response?.data;
    if (typeof data === 'string' && data.length > 0) {
        return data;
    }
    return data?.message || data?.detail || data?.title || GENERIC_ERROR_MESSAGE;
};

export const LinkBuyerByAdmin = createAsyncThunk(
    'timelines/linkBuyerByAdmin',
    async (arg: LinkBuyerByAdminArg, dispatch: any) => {
        const axios = dispatch.getState().core.axios;
        const request: LinkBuyerRequest = { buyerId: arg.buyerId };

        try {
            const response = await axios.post(
                `/api/Marketplace/Engagements/${arg.engagementId}/Buyers/Link`,
                request
            );

            if (response.status !== 200) {
                throw new Error(extractServerMessage(response));
            }

            return response.data as LinkBuyerResult;
        } catch (error: any) {
            const refusal = error?.response
                ? extractServerMessage(error)
                : error?.message || GENERIC_ERROR_MESSAGE;
            createNotification(refusal, 'error');
            throw error;
        }
    }
);
